import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  token: null,
  summary: null,
  summaryLoading: false,
  states: [],
  statesLoading: false,
  cities: [],
  citiesLoading: false,
  currentState: null,
  currentStateLoading: false,
  currentSchool: null,
  currentSchoolLoading: false,
  schools: [],
  schoolsTotal: 0,
  schoolsLoading: false,
  students: [],
  studentsTotal: 0,
  studentsLoading: false,
  sports: [],
  sportsLoading: false,
  teams: [],
  teamsLoading: false,
  studentFilter: {
    sports: [],
    graduationYears: [],
    levels: [],
    minTeamsCount: null,
    gender: null,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
